export default __webpack_public_path__ + "static/media/dpd-logo-local.7bb79588.svg";